import store from '@/store'

export default {
  onGetCustomer (to, from, next) {
    let _filters = {}
    if (!to.query.typeSearch || to.query.typeSearch === 'name') {
      _filters['filters[where][firstName][contains]'] = to.query.search
      _filters['filters[orWhere][lastName][contains]'] = to.query.search
    } else {
      _filters['filters[where][company][contains]'] = to.query.search
    }
    store.dispatch('customers/query', {
      ..._filters,
      limit: 50,
      // page: 2,
      sort: 'firstName ASC'
    })
      .then(clients => {
        if (to.params.id) {
          Promise.all([
            store.dispatch('customers/get', { id: to.params.id, with: 'dealer' }),
            store.dispatch('customerActivities/query', { 'filters[where][customerId][eq]': to.params.id, with: 'activities' })
          ])
            .then(response => {
              next()
            }).catch(error => {
              next(error)
            })
        } else if (clients.data.items.length > 0) {
          Promise.all([
            store.dispatch('customers/get', { id: clients.data.items[0].id, with: 'dealer' }),
            store.dispatch('customerActivities/query', { 'filters[where][customerId][eq]': clients.data.items[0].id, with: 'activities' })
          ])
            .then(response => {
              next()
            })
            .catch(error => {
              next(error)
            })
        } else {
          store.dispatch('customers/clear')
          next()
        }
      })
      .catch(error => {
        next(error)
      })
  },
  onGetListCustomer (to, from, next) {
    store.dispatch('customers/query', { ...to.query, limit: 1000, sort: 'firstName ASC' })
      .then(({data}) => {
        next()
      })
      .catch(error => {
        next(error)
      })
  },
  onGetTasks (to, from, next) {
    let _filters = {}
    if (!to.query.typeSearch || to.query.typeSearch === 'name') {
      _filters['filters[where][firstName][contains]'] = to.query.search ? to.query.search : ''
      _filters['filters[orWhere][lastName][contains]'] = to.query.search ? to.query.search : ''
    } else {
      _filters['filters[where][company][contains]'] = to.query.search ? to.query.search : ''
    }
    store.dispatch('customers/query', {
      ..._filters,
      limit: 1000,
      sort: 'firstName ASC'
    })
      .then(clients => {
        if (to.params.id) {
          store.dispatch('customers/get', { id: to.params.id })
          store.dispatch('tasks/query', {
            ...to.query,
            limit: 1000,
            'filters[where][customerId][eq]': to.params.id,
            with: 'customer'
          })
            .then(response => {
              next()
            })
            .catch(error => {
              next(error)
            })
        } else {
          store.dispatch('customers/query', {
            'filters[where][firstName][contains]': to.query.search,
            'filters[orWhere][lastName][contains]': to.query.search,
            limit: 1000,
            sort: 'firstName ASC'
          })
            .then(({ data }) => {
              store.dispatch('customers/get', { id: clients.data.items[0].id })
              return store.dispatch('tasks/query', {
                ...to.query,
                limit: 1000,
                'filters[where][customerId][eq]': clients.data.items[0].id,
                with: 'customer'
              })
                .then(response => {
                  next()
                })
            })
        }
      })
      .catch(error => {
        next(error)
      })
  },
  onGetList (storeName) {
    return function (to, from, next) {
      let _filters = {}
      if (!to.query.typeSearch || to.query.typeSearch === 'name') {
        _filters['filters[where][firstName][contains]'] = to.query.search ? to.query.search : ''
        _filters['filters[orWhere][lastName][contains]'] = to.query.search ? to.query.search : ''
      } else {
        _filters['filters[where][company][contains]'] = to.query.search ? to.query.search : ''
      }
      store.dispatch('customers/query', {
        ..._filters,
        limit: 1000,
        sort: 'firstName ASC'
      })
        .then(clients => {
          if (to.params.id) {
            store.dispatch('customers/get', { id: to.params.id })
            store.dispatch(storeName + '/query', {
              ...to.query,
              'filters[where][customerId][eq]': to.params.id
            })
              .then(response => {
                next()
              })
              .catch(error => {
                next(error)
              })
          } else if (clients.data.items.length > 0) {
            store.dispatch('customers/get', { id: clients.data.items[0].id })
              .then(response => {
                return store.dispatch(storeName + '/query', {
                  ...to.query,
                  'filters[where][customerId][eq]': clients.data.items[0].id
                })
              })
              .then(response => {
                next()
              })
          } else {
            store.dispatch('customers/clear')
            store.dispatch(storeName + '/clear')
            next()
          }
        })
        .catch(error => {
          next(error)
        })
    }
  },
  guardTabMenu (to, from, next) {
    store.dispatch('app/changeActiveTab', to.name)
    next()
  },
  onEnterCustomer (to, from, next) {
    store.dispatch('customers/query', {limit: 1000, sort: 'firstName ASC'})
      .then(({ data }) => {
        next({ name: 'customers-info', params: { id: data.items[0].id } })
      })
      .catch(error => {
        next(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/guards/customers.guards.js